<div
  *ngIf="!(isAuthorised$ | async)"
  class="name sign-in"
  (click)="signIn()"
  data-lokalise
  data-key="txt_navigation_header_sign_in"
></div>
<div
  *ngIf="isAuthorised$ | async"
  class="name sign-out"
  (click)="signOut()"
  data-lokalise
  data-key="txt_navigation_header_sign_out"
></div>
